var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialXFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7526 4.65852C20.1163 4.24288 20.0741 3.61112 19.6585 3.24744C19.2429 2.88375 18.6111 2.92587 18.2474 3.34151L13.1367 9.18231L8.80001 3.40001C8.61115 3.14821 8.31476 3 8 3H4C3.62123 3 3.27497 3.21402 3.10558 3.5528C2.93619 3.89158 2.97274 4.297 3.20001 4.60001L9.63673 13.1823L4.24742 19.3415C3.88374 19.7571 3.92586 20.3889 4.3415 20.7526C4.75713 21.1163 5.38889 21.0742 5.75258 20.6585L10.8633 14.8177L15.2 20.6C15.3889 20.8518 15.6852 21.0001 16 21.0001H20C20.3788 21.0001 20.725 20.786 20.8944 20.4472C21.0638 20.1084 21.0273 19.703 20.8 19.4L14.3633 10.8177L19.7526 4.65852Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialXFill);
export default __webpack_public_path__ + "static/media/social_x_fill.83f4b07a158e0e26a16b9ad76e20ddb8.svg";
export { ForwardRef as ReactComponent };